import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import cn from 'classnames'
import toast from 'react-hot-toast'
import { observer, useStore } from '@/hooks/storeHooks'
import { useType } from '@/hooks'
import { sendWebNavBuryingPoint } from '@/utils/buryPoints'
import { Link, Icon } from '@/components'
import st from './index.scss'
import { useNavigate } from 'react-router-dom'
import { removeProtocol } from '@/utils'
import { useRequest } from 'ahooks'
import { productCount } from './api'

function Navbar({ className }, ref) {
    const { user, router, isZhumavip } = useStore()
    const type = useType()
    const [hover, setHover] = useState(false)
    const navigate = useNavigate()
    const [showQR, setShowQR] = useState(false)
    const [cartNum, setCartNum] = useState(0)
    const env = location.origin.split('.')[0]
    const pcEnv = process.env.PC_ENV

    useEffect(()=>{
        // user.is_login && getCartNum()
        user.is_login && user.updateCartCount()
    },[user.is_login])

    useImperativeHandle(ref, () => ({
        // 外部调用此方法直接显示错误 如果传入参数 则按参数显示错误信息
        updateCartNum: () => getCartNum(),
    }))

    useEffect(()=>{
      if (location.pathname == '/download') {
        sendWebNavBuryingPoint({ title: 'APP下载',website: '众合在线APP' })
      }
    },[location.pathname])
    // 加入购物车成功之后需要更新header购物车数量
    const { run: getCartNum } = useRequest(()=> user.get(productCount,{userId:user.id,timestamp:new Date().getTime()}).then(res=>{
        if(res.status == 200){
            setCartNum(res.data.count)
        }
    }),{
        manual: true // 手动触发
    })

    async function logout() {
        const res = await user.logout()

        if (!res.status) {
            toast.error(res.error || '未知原因登出失败，请稍后重试')
        } else {
            location.href = '/'
        }
    }

    // 注册或登录跳转
    function registerOrLogin() {
        // 当前页面已经在登录页了，点击不在进行跳转
        console.log(window.location.pathname == ('/w/qrlogin' || '/any/login'))
        if(window.location.pathname == ('/w/qrlogin' || '/any/login')){
            return false
        } else {
            navigate(isZhumavip()
              ? `/w/qrlogin?from=${encodeURIComponent(
                  encodeURI(removeProtocol())
              )}`
              : `/any/login?from=${encodeURIComponent(
                  encodeURI(removeProtocol())
              )}`)
        }
    }

    // 购物车
    function goCart() {
        sendWebNavBuryingPoint({ website: '购物车'})
        if(user.is_login){
            // 跳转购物车
            navigate(`/fakao/my/shoppingCart?isNav=1`)
        }else{
            navigate(isZhumavip()
              ? `/w/qrlogin?from=/fakao/my/shoppingCart?isNav=1`
              : `/any/login?from=/fashuo/my/shoppingCart?isNav=1`)
            
        }
    }

    return (
        <div className={cn(st['navbar'], className)}>
            <div className={cn('content', st['navbar-tripe'])}>
                <div className={st['navbar-left']}>
                    <Link
                        to={`https://${pcEnv}.zhongheschool.com/fakao/`}
                        className={cn({
                          [st.navigate]: true,
                          [st['hover']]: type == 'fakao' && !isZhumavip() && !['/w/downloadpc', '/download'].includes(location.pathname)
                        })}
                        useorigin={true}
                        // onClick={() => { sendWebNavBuryingPoint({ website: '众合法考', title: '首页' })}}
                    >
                        众合法考
                    </Link>
                    <Link
                        to={`https://${pcEnv}.zhongheschool.com/fashuo/`}
                        className={cn({
                          [st.navigate]: true,
                          [st['hover']]: type == 'fashuo' && !isZhumavip() && !['/w/downloadpc', '/download'].includes(location.pathname)
                        })}
                        useorigin={true}
                        // onClick={() => { sendWebNavBuryingPoint({ website: '众合法硕', title: '首页' }) }}
                    >
                        众合法硕
                    </Link>
                    <Link
                      to={`https://${pcEnv}.zhumavip.com`}
                      className={cn({
                        [st.navigate]: true,
                        [st['hover']]: isZhumavip() && !['/w/downloadpc', '/download'].includes(location.pathname)
                      })}
                      useorigin={true}
                      // onClick={() => { sendWebNavBuryingPoint({ website: '竹马官网', title: '首页' }) }}
                    >
                      竹马官网
                    </Link>
                    <Link
                      className={st.navigate}
                      onClick={() => { sendWebNavBuryingPoint({ website: '国桓官网', title: '首页' }) }}
                      to={`//${pcEnv}.guohuanlaw.com/`} target="_blank">
                        国桓律所
                    </Link>
                    <div
                      className={cn(
                        {
                          [st.navigate]: true, [st.download]: true,
                          [st.hover]: ['/w/downloadpc','/download'].includes(location.pathname)
                        }
                      )}
                      onMouseEnter={() => setHover(true)}
                      onMouseLeave={() => setHover(false)}
                    >
                      App下载
                      <Icon
                        name={hover ? 'zhankaibeifen' : 'zhankaibeifen-copy'}
                        className={st['close-icon']}
                      />
                      <div className={st.downloadInfo}>
                        <Link className={st.link}
                          target="_blank"
                          to={`https://${pcEnv}.zhumavip.com/w/downloadpc`}
                          // onClick={() => { sendWebNavBuryingPoint({ website: '竹马APP' }) }}
                        >
                          <img
                            src={require('@/public/images/downloadlogo.png')}
                          />
                          竹马
                        </Link>
                        <Link className={cn(st.zhonghe, st.link)}
                          // onClick={() => { sendWebNavBuryingPoint({ website: '众合在线APP' }) }}
                          to={`https://${pcEnv}.zhongheschool.com/download`} target="_blank"
                        >
                          <img
                            src={require('@/public/images/downl_logo.png')}
                          />
                          众合在线
                        </Link>
                      </div>
                    </div>
                </div>
                <div className={st['navbar-right']}>
                    <div className={st['daka-box']}
                      onMouseEnter={() => setShowQR(true)}
                      onMouseLeave={() => setShowQR(false)}
                    >
                      <Icon
                        name='daka'
                        className={st['daka-icon']}
                      />
                      <p>打卡</p>
                      <div className={st.qrcode}>
                        <img className={st['download-qr']} src='https://osscdn2.zhongheschool.com/common/defaultType/202312/202312081601350420.png' />
                    </div>
                    </div>
                    <div className={st['phone-box']}>
                        <Icon
                          name='bianzu'
                          className={st['phone-icon']}
                        />
                        <span className={st['text']}>400-6116-858</span>
                    </div>
                    <div onClick={goCart} className={cn(st['cart-box'], location.href.indexOf('my/shoppingCart') != -1 && st.hover)}>
                      <div className={st['cart-left-box']}>
                        <Icon
                          name='gouwuche'
                          className={st['cart-icon']}
                        />
                        {/* {user.is_login && cartNum > 0?(
                        <span className={st['cart-counter']}>
                            {cartNum > 99 ? '99+' : cartNum}
                        </span>
                        ):''} */}
                        {user.is_login && user.cartCount > 0?(
                        <span className={st['cart-counter']}>
                            {user.cartCount > 99 ? '99+' : user.cartCount}
                        </span>
                        ):''}
                      </div>
                        <span className={st['text']}>购物车</span>
                    </div>
                    {user.is_login ? (
                      <>
                        <div className={st['user-box']} id="guide_user">
                            <Link
                                to="/fakao/my/orders"
                                className={st['user-info']}
                            >
                              <div className={cn({
                                [st.userpic]: true,
                                [st['border-huangjin']]: user?.member_name == '黄金会员',
                                [st['border-baiyin']]: user?.member_name == '白银会员',
                                [st['border-bojin']]: user?.member_name == '铂金会员'
                              })}>
                                <img
                                  src={user?.mask}
                                  className={st['user-mask']}
                                />
                                <img
                                  src={user?.member_icon}
                                  className={st['v-icon']}
                                />
                              </div>
                              {user.nickname}
                            </Link>
                        </div>
                        <div className={st['shu']}></div>
                        <div
                            className={st.login}
                            onClick={() => logout()}
                        >
                            退出
                        </div>
                       </>
                    ) : (
                        <>
                            {/* 竹马走老项目的登录 暂时没有扫码登录功能 */}
                            <div
                                onClick={registerOrLogin}
                                className={st.login}
                            >
                                注册
                            </div>
                            <div className={st['shu']}></div>
                            {/* 竹马走老项目的登录 暂时没有扫码登录功能 */}
                            <div
                                onClick={registerOrLogin}
                                className={st.login}
                            >
                                登录
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default observer(Navbar, { forwardRef: true });